import React, { useState } from "react";
import "./Accordion.css";
import { Plus, Minus } from "phosphor-react";
const Accordion = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div
      className="accordion"
    >
      <div className={`accordion-title font-semibold t1 ${isOpen ? "active" : ""}`} onClick={() => {
        setIsOpen(!isOpen);
      }}>{title}&nbsp; 
      {isOpen? 
        <Minus size={15} />
        :
        <Plus size={15} />
    }
      </div>
      <div className="accordion-content t4 font-medium" aria-expanded={isOpen}>
        {children}
      </div>
    </div>
  );
};

export default Accordion;
